const variablesApplicationConfig = {
  desktopBreakpoint: 1200,
  tabletBreakpoint: 1056,
  mobileBreakpoint: 767,
}

export default variablesApplicationConfig
